<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="TOC">
<h2 class="contentsHead" style="text-indent: 0%;">Contents</h2>
<div class="contentsEntry" id="chapter_01">
<p class="contentsEntryNumber"><a href="#/005chapter01#chapter01">1</a></p>
<p class="contentsEntryText">Suzanne Blume finished up her day’s lecture on the First…</p>
</div>
<div class="contentsEntry" id="chapter_02">
<p class="contentsEntryNumber"><a href="#/006chapter02#chapter02">2</a></p>
<p class="contentsEntryText">Suzanne had just got back from court Thursday and was…</p>
</div>
<div class="contentsEntry" id="chapter_03">
<p class="contentsEntryNumber"><a href="#/007chapter03#chapter03">3</a></p>
<p class="contentsEntryText">Beverly climbed the steep stairway from the 103rd Street subway…</p>
</div>
<div class="contentsEntry" id="chapter_04">
<p class="contentsEntryNumber"><a href="#/008chapter04#chapter04">4</a></p>
<p class="contentsEntryText">Elena was furious when Sam moved out. She knew it…</p>
</div>
<div class="contentsEntry" id="chapter_05">
<p class="contentsEntryNumber"><a href="#/009chapter05#chapter05">5</a></p>
<p class="contentsEntryText">Rachel was silent for an entire week. Suzanne tried to…</p>
</div>
<div class="contentsEntry" id="chapter_06">
<p class="contentsEntryNumber"><a href="#/010chapter06#chapter06">6</a></p>
<p class="contentsEntryText">Suzanne spent an hour dressing for lunch. Jake had called…</p>
</div>
<div class="contentsEntry" id="chapter_07">
<p class="contentsEntryNumber"><a href="#/011chapter07#chapter07">7</a></p>
<p class="contentsEntryText">Beverly got Elena when she called. “So how come the…</p>
</div>
<div class="contentsEntry" id="chapter_08">
<p class="contentsEntryNumber"><a href="#/012chapter08#chapter08">8</a></p>
<p class="contentsEntryText">Suzanne had been in court all day. Her client’s suit…</p>
</div>
<div class="contentsEntry" id="chapter_09">
<p class="contentsEntryNumber"><a href="#/013chapter09#chapter09">9</a></p>
<p class="contentsEntryText">Beverly was talking to a worker at a machine in…</p>
</div>
<div class="contentsEntry" id="chapter_10">
<p class="contentsEntryNumber"><a href="#/014chapter10#chapter10">10</a></p>
<p class="contentsEntryText">Elena was bored. She saw high school stretching on forever.</p>
</div>
<div class="contentsEntry" id="chapter_11">
<p class="contentsEntryNumber"><a href="#/015chapter11#chapter11">11</a></p>
<p class="contentsEntryText">Suzanne and Elena were eating an early supper of Chinese…</p>
</div>
<div class="contentsEntry" id="chapter_12">
<p class="contentsEntryNumber"><a href="#/016chapter12#chapter12">12</a></p>
<p class="contentsEntryText">Beverly hated the physical therapist pulling on her arm and…</p>
</div>
<div class="contentsEntry" id="chapter_13">
<p class="contentsEntryNumber"><a href="#/017chapter13#chapter13">13</a></p>
<p class="contentsEntryText">Suzanne borrowed Marta’s van to transport Beverly to Brookline for…</p>
</div>
<div class="contentsEntry" id="chapter_14">
<p class="contentsEntryNumber"><a href="#/018chapter14#chapter14">14</a></p>
<p class="contentsEntryText">Elena hated school. She hated all the girls who gossiped…</p>
</div>
<div class="contentsEntry" id="chapter_15">
<p class="contentsEntryNumber"><a href="#/019chapter15#chapter15">15</a></p>
<p class="contentsEntryText">Beverly dreaded going into the rehab center because it sounded…</p>
</div>
<div class="contentsEntry" id="chapter_16">
<p class="contentsEntryNumber"><a href="#/020chapter16#chapter16">16</a></p>
<p class="contentsEntryText">“Are you sure you’re not rushing into marriage because you’re…</p>
</div>
<div class="contentsEntry" id="chapter_17">
<p class="contentsEntryNumber"><a href="#/021chapter17#chapter17">17</a></p>
<p class="contentsEntryText">Elena was annoyed the guys were hogging the driving. Ever…</p>
</div>
<div class="contentsEntry" id="chapter_18">
<p class="contentsEntryNumber"><a href="#/022chapter18#chapter18">18</a></p>
<p class="contentsEntryText">Elena said, “So what’s going to happen in California, when…</p>
</div>
<div class="contentsEntry" id="chapter_19">
<p class="contentsEntryNumber"><a href="#/023chapter19#chapter19">19</a></p>
<p class="contentsEntryText">Suzanne was sitting at Marta’s kitchen table, her head in…</p>
</div>
<div class="contentsEntry" id="chapter_20">
<p class="contentsEntryNumber"><a href="#/024chapter20#chapter20">20</a></p>
<p class="contentsEntryText">Beverly had been invisible for months. She spoke and no…</p>
</div>
<div class="contentsEntry" id="chapter_21">
<p class="contentsEntryNumber"><a href="#/025chapter21#chapter21">21</a></p>
<p class="contentsEntryText">Alexa appeared at Suzanne’s office. “Suze, we better have lunch…</p>
</div>
<div class="contentsEntry" id="chapter_22">
<p class="contentsEntryNumber"><a href="#/026chapter22#chapter22">22</a></p>
<p class="contentsEntryText">Elena noticed it the third week she was working there,…</p>
</div>
<div class="contentsEntry" id="chapter_23">
<p class="contentsEntryNumber"><a href="#/027chapter23#chapter23">23</a></p>
<p class="contentsEntryText">Beverly liked her new computer. She had resisted using one…</p>
</div>
<div class="contentsEntry" id="chapter_24">
<p class="contentsEntryNumber"><a href="#/028chapter24#chapter24">24</a></p>
<p class="contentsEntryText">Monday morning, Elena lay in bed in the room she…</p>
</div>
<div class="contentsEntry" id="chapter_25">
<p class="contentsEntryNumber"><a href="#/029chapter25#chapter25">25</a></p>
<p class="contentsEntryText">Alexa came to see her with Celeste for backup. They…</p>
</div>
<div class="contentsEntry" id="chapter_26">
<p class="contentsEntryNumber"><a href="#/030chapter26#chapter26">26</a></p>
<p class="contentsEntryText">Beverly often wished she could say all she wanted to,…</p>
</div>
<div class="contentsEntry" id="chapter_27">
<p class="contentsEntryNumber"><a href="#/031chapter27#chapter27">27</a></p>
<p class="contentsEntryText">Elena had never felt such a sense of fullness, not…</p>
</div>
<div class="contentsEntry" id="chapter_28">
<p class="contentsEntryNumber"><a href="#/032chapter28#chapter28">28</a></p>
<p class="contentsEntryText">Suzanne had her checkbook and returned checks spread out on…</p>
</div>
<div class="contentsEntry" id="chapter_29">
<p class="contentsEntryNumber"><a href="#/033chapter29#chapter29">29</a></p>
<p class="contentsEntryText">Elena was always super hot on Mondays, because usually Jim…</p>
</div>
<div class="contentsEntry" id="chapter_30">
<p class="contentsEntryNumber"><a href="#/034chapter30#chapter30">30</a></p>
<p class="contentsEntryText">After Elena made them lunch, her granddaughter went upstairs, and…</p>
</div>
<div class="contentsEntry" id="chapter_31">
<p class="contentsEntryNumber"><a href="#/035chapter31#chapter31">31</a></p>
<p class="contentsEntryText">Suzanne canceled her litigation class. Her hands were shaking so…</p>
</div>
<div class="contentsEntry" id="chapter_32">
<p class="contentsEntryNumber"><a href="#/036chapter32#chapter32">32</a></p>
<p class="contentsEntryText">Elena felt deeply ashamed, not because she had been with…</p>
</div>
<div class="contentsEntry" id="chapter_33">
<p class="contentsEntryNumber"><a href="#/037chapter33#chapter33">33</a></p>
<p class="contentsEntryText">Suzanne had to go to Framingham to see Maxine, whose…</p>
</div>
<div class="contentsEntry" id="chapter_34">
<p class="contentsEntryNumber"><a href="#/038chapter34#chapter34">34</a></p>
<p class="contentsEntryText">Beverly woke to blurred grayness, her head throbbing. Her right…</p>
</div>
<div class="contentsEntry" id="chapter_35">
<p class="contentsEntryNumber"><a href="#/039chapter35#chapter35">35</a></p>
<p class="contentsEntryText">Elena was glad when Grandma was transferred from the hospital…</p>
</div>
<div class="contentsEntry" id="chapter_36">
<p class="contentsEntryNumber"><a href="#/040chapter36#chapter36">36</a></p>
<p class="contentsEntryText">The Friday before Suzanne was finally to argue Maxine’s appeal,…</p>
</div>
<div class="contentsEntry" id="chapter_37">
<p class="contentsEntryNumber"><a href="#/041chapter37#chapter37">37</a></p>
<p class="contentsEntryText">Beverly’s words beat around in her head like birds trapped…</p>
</div>
<div class="contentsEntry" id="chapter_38">
<p class="contentsEntryNumber"><a href="#/042chapter38#chapter38">38</a></p>
<p class="contentsEntryText">Suzanne read Rachel’s E-mail with an increasing sense of separation…</p>
</div>
<div class="contentsEntry" id="chapter_39">
<p class="contentsEntryNumber"><a href="#/043chapter39#chapter39">39</a></p>
<p class="contentsEntryText">Elena could not say she liked her job, but she…</p>
</div>
<div class="contentsEntry" id="chapter_40">
<p class="contentsEntryNumber"><a href="#/044chapter40#chapter40">40</a></p>
<p class="contentsEntryText">Beverly lay in the bed in the room she had…</p>
</div>
<div class="contentsEntry" id="chapter_41">
<p class="contentsEntryNumber"><a href="#/045chapter41#chapter41">41</a></p>
<p class="contentsEntryText">Suzanne came abruptly awake. It was 2:00 A.M. and the phone…</p>
</div>
<div class="contentsEntry" id="chapter_42">
<p class="contentsEntryNumber"><a href="#/046chapter42#chapter42">42</a></p>
<p class="contentsEntryText">Elena started going out with Sean, she suspected, because she…</p>
</div>
<div class="contentsEntry" id="chapter_43">
<p class="contentsEntryNumber"><a href="#/047chapter43#chapter43">43</a></p>
<p class="contentsEntryText">Beverly had been exactly twenty-nine, yes, when Suzanne caught German…</p>
</div>
<div class="contentsEntry" id="chapter_44">
<p class="contentsEntryNumber"><a href="#/048chapter44#chapter44">44</a></p>
<p class="contentsEntryText">“Now he’s back on the talk show circuit with this…</p>
</div>
<div class="contentsEntry" id="chapter_45">
<p class="contentsEntryNumber"><a href="#/049chapter45#chapter45">45</a></p>
<p class="contentsEntryText">Suzanne thought Rachel, in trying to act cheerful, sounded so…</p>
</div>
<div class="contentsEntry" id="chapter_46">
<p class="contentsEntryNumber"><a href="#/050chapter46#chapter46">46</a></p>
<p class="contentsEntryText">Elena listened to her mother going on about this case…</p>
</div>
<div class="contentsEntry" id="chapter_47">
<p class="contentsEntryNumber"><a href="#/051chapter47#chapter47">47</a></p>
<p class="contentsEntryText">Beverly wanted to keep the two bottles on top of…</p>
</div>
<div class="contentsEntry" id="chapter_48">
<p class="contentsEntryNumber"><a href="#/052chapter48#chapter48">48</a></p>
<p class="contentsEntryText">“Getting divorced is such a lot of work. I don’t…</p>
</div>
<div class="contentsEntry" id="chapter_49">
<p class="contentsEntryNumber"><a href="#/053chapter49#chapter49">49</a></p>
<p class="contentsEntryText">Elena looked in on her mother. Suzanne had put on…</p>
</div>
<div class="contentsEntry" id="chapter_50">
<p class="contentsEntryNumber"><a href="#/054chapter50#chapter50">50</a></p>
<p class="contentsEntryText">Suzanne placed the yahrzeit candle for her mother in the…</p>
</div>
<p class="spaceBreak"> </p>
<div class="contentsEntry1" id="aboutauthor_page">
<p class="contentsEntryName"><a href="#/055aboutauthorpage#aboutauthorpage">About the Author</a></p>
</div>
<div class="contentsEntry1" id="review_page">
<p class="contentsEntryName"><a href="#/056reviewpage#reviewpage">Praise</a></p>
</div>
<div class="contentsEntry1" id="adcard_page">
<p class="contentsEntryName"><a href="#/057adcardpage#adcardpage">Other Books by Marge Piercy</a></p>
</div>
<div class="contentsEntry1" id="copyright_page">
<p class="contentsEntryName"><a href="#/058copyrightpage#copyrightpage">Copyright</a></p>
</div>
<div class="contentsEntry1" id="aboutpublisher_page">
<p class="contentsEntryName"><a href="#/059aboutpublisherpage#aboutpublisherpage">About the Publisher</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004-TOC.vue?6583c51c